import { tns } from 'tiny-slider/src/tiny-slider';
const relatedAccessories = document.querySelectorAll('.component-related-accessories');

if (relatedAccessories.length > 0) {
    let sliderRelatedAccessories = tns({
      container: '.component-related-accessories__slider',
      items: 1,
      center: true,
      controls: true,
      gutter: 10,
      controlsPosition: 'bottom',
      loop: false,
      swipeAngle: false,
      speed: 400,
      preventScrollOnTouch: 'auto',
      autoplay: false,
      responsive: {
        425: {
          items: 1,
          center: true,
    
        },
        500: {
          items: 2,
          center: false,
          
        },
        750: {
          items: 3,
          center: false,
        
        },
        1000: {
          items: 4,
          center: false,
        
        },
        1100: {
          items: 5,
          center: false,
          
        },
        1400: {
          items: 6,
          center: false,
          
        },
      },
    });

}

